export enum LinerActionsTypes {
  READ = "@@LINER read liners",
  READ_STATUS = "@@LINER read status liners",
  CREATE = "@@LINER create liners",
  CREATE_STATUS = "@@LINER create status liners",
  UPDATE = "@@LINER update liners",
  UPDATE_STATUS = "@@LINER update status liners"
}
